import { uiHelper, permissionHelper } from "@/core/utils";
import { JWT_CONSTANTS } from "@/core/constants";

export const jwtHelper = {
  setToken,
  setProfile,
  setLastActivityTime,
  setSessionExpirationTime,
  getToken,
  getProfile,
  getBearerToken,
  getLastActivityTime,
  getSessionExpirationTime,
  removeProfile,
  removeToken,
  removeLastActivityTime,
  removeSessionExpirationTime,
};

function getToken() {
  return uiHelper.getLocalStorage(JWT_CONSTANTS.TOKEN);
}

function setToken(keyValue) {
  uiHelper.setLocalStorage(JWT_CONSTANTS.TOKEN, keyValue);
}

function setProfile(keyValue) {
  permissionHelper.setUserPermissions(keyValue);
  uiHelper.setLocalStorage(JWT_CONSTANTS.PROFILE, JSON.stringify(keyValue));
}

function getBearerToken() {
  return (
    JWT_CONSTANTS.JWT_TOKEN_TYPE + uiHelper.getLocalStorage(JWT_CONSTANTS.TOKEN)
  );
}
function getProfile() {
  let profile = uiHelper.getLocalStorage(JWT_CONSTANTS.PROFILE);
  return JSON.parse(profile);
}

function getLastActivityTime() {
  return parseInt(uiHelper.getLocalStorage(JWT_CONSTANTS.LAST_ACTIVITY_TIME));
}

function setLastActivityTime() {
  uiHelper.setLocalStorage(
    JWT_CONSTANTS.LAST_ACTIVITY_TIME,
    JSON.stringify(new Date().getTime())
  );
}

function removeToken() {
  uiHelper.removeLocalStorage(JWT_CONSTANTS.TOKEN);
}

function removeProfile() {
  uiHelper.removeLocalStorage(JWT_CONSTANTS.PROFILE);
}

function removeLastActivityTime() {
  uiHelper.removeLocalStorage(JWT_CONSTANTS.LAST_ACTIVITY_TIME);
}

function setSessionExpirationTime(time) {
  let originalExpirationHour = time * 1000;
  let newTime = time != 0 ? new Date().getTime() + originalExpirationHour : 0;

  uiHelper.setLocalStorage(
    JWT_CONSTANTS.SESSION_EXPIRATION_TIME,
    JSON.stringify(newTime)
  );
}

function getSessionExpirationTime() {
  return parseInt(
    uiHelper.getLocalStorage(JWT_CONSTANTS.SESSION_EXPIRATION_TIME)
  );
}

function removeSessionExpirationTime() {
  uiHelper.removeLocalStorage(JWT_CONSTANTS.SESSION_EXPIRATION_TIME);
}
